import React, { lazy } from 'react';
export function Bonuses() {
  return <section id="bonuses" className="py-[80px] px-5 bg-white scroll-mt-16" data-id="element-9">
      <div className="max-w-[860px] mx-auto" data-id="element-10">
        <h2 className="text-[clamp(28px,4vw,40px)] font-black text-brand-navy mb-4 text-center font-montserrat" data-id="element-11">
          3 Bonos de Regalo
        </h2>
        <p className="text-lg text-brand-textSecondary text-center mb-12 max-w-[600px] mx-auto" data-id="element-12">
          Incluidos gratis con tu compra de{' '}
          <strong className="text-brand-emerald font-black" data-id="element-13">$14</strong>
        </p>

        <div className="flex flex-col gap-6" data-id="element-14">
          {/* Bono 1 */}
          <div className="bg-white border border-brand-border rounded-xl p-6 shadow-md flex flex-col sm:flex-row gap-6 items-center sm:items-start transition-all hover:shadow-lg relative overflow-hidden" data-id="element-15">
            <div className="absolute top-3 right-3 bg-brand-emerald text-white text-[10px] font-black uppercase tracking-wider px-3 py-1 rounded-full" data-id="element-16">
              ✅ INCLUIDO
            </div>
            <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/03_-_Mano_depositando_billetes_y_objetos_financieros.png?v=1775530363" alt="Bono 1 - Blindaje Financiero" loading="lazy" className="w-full sm:w-32 h-48 sm:h-32 object-cover rounded-lg shrink-0" data-id="element-17" />
            <div className="text-center sm:text-left" data-id="element-18">
              <h3 className="text-xl font-black text-brand-navy mb-2" data-id="element-19">
                BONO 1: Blindaje Anti-Deportación Financiera
              </h3>
              <p className="text-base text-brand-textSecondary leading-relaxed m-0" data-id="element-20">
                Maneja tus cuentas con inteligencia y seguridad legal. ITIN,
                bancos y más.
              </p>
            </div>
          </div>

          {/* Bono 2 */}
          <div className="bg-white border border-brand-border rounded-xl p-6 shadow-md flex flex-col sm:flex-row gap-6 items-center sm:items-start transition-all hover:shadow-lg relative overflow-hidden" data-id="element-21">
            <div className="absolute top-3 right-3 bg-brand-emerald text-white text-[10px] font-black uppercase tracking-wider px-3 py-1 rounded-full" data-id="element-22">
              ✅ INCLUIDO
            </div>
            <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/04_Llaves_de_casa_frente_a_hogar_nuevo.png?v=1775530362" alt="Bono 2 - Mapa Ruta Casa Propia" loading="lazy" className="w-full sm:w-32 h-48 sm:h-32 object-cover rounded-lg shrink-0" data-id="element-23" />
            <div className="text-center sm:text-left" data-id="element-24">
              <h3 className="text-xl font-black text-brand-navy mb-2" data-id="element-25">
                BONO 2: El Mapa al Patrimonio Familiar
              </h3>
              <p className="text-base text-brand-textSecondary leading-relaxed m-0" data-id="element-26">
                Cómo calificar para tu casa propia trabajando por tu cuenta.
              </p>
            </div>
          </div>

          {/* Bono 3 */}
          <div className="bg-white border border-brand-border rounded-xl p-6 shadow-md flex flex-col sm:flex-row gap-6 items-center sm:items-start transition-all hover:shadow-lg relative overflow-hidden" data-id="element-27">
            <div className="absolute top-3 right-3 bg-brand-emerald text-white text-[10px] font-black uppercase tracking-wider px-3 py-1 rounded-full" data-id="element-28">
              ✅ INCLUIDO
            </div>
            <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/05_Trabajador_de_construccion_junto_al_camion.png?v=1775530363" alt="Bono 3 - De Operador a Dueño" loading="lazy" className="w-full sm:w-32 h-48 sm:h-32 object-cover rounded-lg shrink-0" data-id="element-29" />
            <div className="text-center sm:text-left" data-id="element-30">
              <h3 className="text-xl font-black text-brand-navy mb-2" data-id="element-31">
                BONO 3: De Operador a Dueño de Negocio
              </h3>
              <p className="text-base text-brand-textSecondary leading-relaxed m-0" data-id="element-32">
                Cómo formalizar tu LLC y cobrar lo que realmente vales.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}